/**
 * StagingBanner — banner sticky superior visible solo en el env
 * de staging. Evita que el staff confunda staging con prod
 * (FR-002 + R-004 de feature 004).
 *
 * Por default lee `detectEnv()` para decidir si renderiza. La prop
 * `visible` permite tests deterministicos sin tocar window.location.
 */
import type { JSX } from "react";

import { detectEnv } from "../../lib/env";
import "./styles/staging-banner.css";

export interface StagingBannerProps {
  /** Override explícito del comportamiento default (basado en hostname). */
  visible?: boolean;
}

export function StagingBanner({ visible }: StagingBannerProps): JSX.Element | null {
  const shouldShow = visible ?? detectEnv() === "staging";
  if (!shouldShow) return null;

  return (
    <div className="staging-banner" role="status" aria-live="polite">
      <span className="staging-banner__dot" aria-hidden="true" />
      <span className="staging-banner__label">STAGING</span>
      <span className="staging-banner__hint">
        Estás viendo el entorno de pruebas
      </span>
    </div>
  );
}

export default StagingBanner;
